<app-tabla-general [displayedColumns]="displayedColumns" [moduloActual]="'visitantes'" (tipoVisitasChange)="onTipoVisitasChange($event)"></app-tabla-general>
<router-outlet></router-outlet>